export { default } from './ProductImage';
export type { ImageBox } from './srcSet';
